import $ from 'jquery'
import 'select2'
import 'select2/dist/css/select2.min.css'
import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.css'

document.addEventListener('DOMContentLoaded', () => {
  $('.js-searchable').select2({
    theme: 'bootstrap-5',
    width: 'resolve',
  })
})
